var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isComponentVisible())?_c('div',[_c('div',{staticClass:"w-100"},[_c('b-progress',{attrs:{"value":_vm.value,"max":_vm.max}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }